import * as React from 'react';
import '../styles/other.scss';
import {Link} from "gatsby";
import { useStaticQuery, graphql } from "gatsby"
import {translate} from "../helpers/lang";
import {useNav} from "../hooks/useNav";

export const Footer = ({lang}) => {
    const {slugTranslate} = useNav(lang);

    const data = useStaticQuery(graphql`
    {
      allHome {
        edges {
          node {
            data {
              contact {
                addr {
                  en
                  fr
                }
                email
                intro {
                  en
                  fr
                }
                map
                phone
                title {
                  en
                  fr
                }
              }
            }
          }
        }
      }
    }
  `)
   const contact = data?.allHome?.edges?.[0]?.node?.data?.contact;


  const t = translate(lang ,contact);

    return(
        <footer id={slugTranslate('contact')}   className="footer">
            <div className="container">
                <h2 className="title"> {t('title')}</h2>
                <div className="footer__container">
                    <div className="footer__content">
                        <h3 className="footer__title"> {t('intro')}</h3>
                        <div className="footer__info">
                            <p><a href={t('map',true)}   rel="noreferrer"   target="_blank">{t('addr')} </a></p>
                            <p><a href={"tel:"+contact.phone}> {contact.phone}</a></p>
                            <p><a href={"mailto:"+contact.email}>{contact.email}</a></p>
                        </div>
                    </div>
                    <div className="footer__logo">
                        <Link to={"/"+lang+"/"+slugTranslate('home') } title="20k logo">
                            <svg x="0px" y="0px" viewBox="230 320 550 300">
                                <path d="M298.6,555.3h96.9v45.3H249.3v-45.3c0-66.3,98-60.1,98-95.2c0-9.6-7.4-18.1-22.1-18.1 c-15.9,0-27.8,7.4-27.8,19.8h-48.2c0-36.3,34.6-65.2,76.5-65.2c39.1,0,69.7,24.9,69.7,65.2C395.5,529.5, 298.6,522.7,298.6,555.3"/>
                                <path d="M597.5,472.5v55c0,51.9-41.1,75.9-81.6,75.9c-40.5,0-81.6-24.1-81.6-75.9v-55c0-51.9,41.1-75.9,81.6-75.9 C556.4,396.6,597.5,420.7,597.5,472.5 M549.3,527.5v-55c0-20.4-15.9-30.6-33.4-30.6c-17.6,0-33.4,10.2-33.4,30.6v55 c0,20.4,15.9,30.6,33.4,30.6C533.4,558.1,549.3,547.9,549.3,527.5"/>
                                <polygon points="697.1,467.1 746.3,538.2 710.5,538.2 676.8,490 666.4,501.8 666.4,538.2 636,538.2 636,411 666.4,411 666.4,457.2 707.1,411 746.3,411"/>
                                <rect x="636" y="576.1" width="114.7" height="27.3"/>
                            </svg>
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}
